import * as React from 'react';
import * as styles from './styles.css';

import { HonestWork, PopupDirection } from '@cian/honestwork-component';

import { ArticleHeading1 } from '@cian/ui-kit';
import { IModerationInfo, IUserLevelInfo } from '../../models/agent';
import { TRealtor } from '../../models/realtor';
import { AgentType, RgrCertificate } from '../RgrCertificate';
import { PartnerTooltip } from './components/PartnerTooltip';
import { PartnerBadge } from './components/PartnerBadge';
import { Approval } from '../Approval';
import { UserWorkHonestlyInfo } from './components/UserWorkHonestlyInfo';

export interface INameProps {
  hasFairplay: TRealtor['hasFairplay'];
  userLevelInfo?: IUserLevelInfo;
  name: TRealtor['name'];
  isCianPartner: TRealtor['isCianPartner'];
  hasRgrParticipation: boolean;
  moderationInfo?: IModerationInfo | null;
}

export const Name = (props: INameProps) => {
  const { hasFairplay, userLevelInfo, name, isCianPartner, hasRgrParticipation, moderationInfo } = props;

  return (
    <div className={styles['name-container']}>
      <div className={styles['title']}>
        <span className={styles['agent-name']}>
          <ArticleHeading1>
            <span className={styles['name']}>{name}</span>
            <span className={styles['badges']}>
              {userLevelInfo && (
                <UserWorkHonestlyInfo levelNumber={userLevelInfo.levelOrder} levelName={userLevelInfo.levelName} />
              )}
              {hasFairplay && !userLevelInfo && (
                <HonestWork
                  direction={PopupDirection.RIGHT}
                  className={styles['honest_work']}
                  iconStyles={{ width: '22px', height: '24px' }}
                />
              )}
              {isCianPartner && <PartnerTooltip master={<PartnerBadge />} />}
            </span>
          </ArticleHeading1>
        </span>

        <Approval moderationInfo={moderationInfo} />
      </div>

      {hasRgrParticipation && <RgrCertificate type={AgentType.Realtor} size="M" withText={true} />}
    </div>
  );
};
